import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import predictionsReducer from './predictions';
import servicesConfigsReducer from './servicesConfigs';
import classesReducer from './classes';
import labelsReducer from './labels';
import configReducer from './config';
import agentsDataReducer from './agentsData';
import settingsDataReducer from './settings';
import lookupTableReducer from './LookupTable';
import imageReducer from './image';
import flagsReducer from './flags';

export default combineReducers({
  toastr: toastrReducer,
  servicesConfigs: servicesConfigsReducer,
  predictions: predictionsReducer,
  classes: classesReducer,
  labels: labelsReducer,
  config: configReducer,
  agentsData: agentsDataReducer,
  settings: settingsDataReducer,
  lookupTable: lookupTableReducer,
  image: imageReducer,
  flags: flagsReducer,
});
